import { render, staticRenderFns } from "./bindEmail.vue?vue&type=template&id=3f04f46c&scoped=true&"
import script from "./bindEmail.vue?vue&type=script&lang=js&"
export * from "./bindEmail.vue?vue&type=script&lang=js&"
import style0 from "./bindEmail.vue?vue&type=style&index=0&id=3f04f46c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f04f46c",
  null
  
)

export default component.exports